<template>
  <b-row>
    <b-col cols="auto">
      <b-button variant="primary" class="btn__review" @click.stop="$emit('click')">
        {{ isOwner ? 'Review' : 'Assessment' }}
      </b-button>
      <BaseTagSubmissionStatus
        v-if="isOwner"
        :is-owner="isOwner"
        :review-pending-count="reviewPendingCount"
        :status="status"
        class="mx-3"
      />
    </b-col>
  </b-row>
</template>

<script>
import Status from '@/models/Status';
import { assessmentStatusMixin } from '@/mixins/assessmentStatusMixin';
import BaseTagSubmissionStatus from '@/components/base-components/BaseTagSubmissionStatus';

export default {
  name: 'ReviewSubmission',

  components: { BaseTagSubmissionStatus },

  mixins: [assessmentStatusMixin],

  props: {
    isOwner: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    status() {
      return Status.reviewPending;
    }
  }
};
</script>
